// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.word-menu {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 250px;
  text-align: center;
  background-color: var(--tg-theme-bg-color);
  padding: 25px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  z-index: 1100;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.word-menu * {
  touch-action: pan-y;
}

.word-display {
  color: var(--tg-theme-button-color); /* Синий цвет */
  font-size: 24px;
  margin-bottom: 3px;
}

.word-menu-settings {
  width: 95%;
  margin-top: 4px;
  margin-bottom: 4px;
}

.word-menu-item {
  width: 100%;
  margin-top: 6px;
  margin-bottom: 6px;
  background-color: rgba(154, 154, 154, 0.1);
  border-radius: 10px;
}

.word-menu-item-checkbox {
  height: 20px;
  width: 20px;
  margin-left: 2px;
  margin-right: 5px;
}

.word-menu-item:hover {
  background-color: rgba(154, 154, 154, 0.15);
}


.word-input-field {
  background-color: var(--tg-theme-bg-color);
  color: var(--tg-theme-text-color);
  width: 95%;
  font-size: 16px;
  border-radius: 12px;
  border-color: var(--tg-theme-button-color);
  border-width: 2px;  /* Задаем толщину рамки */
  border-style: solid;  /* Убедимся, что стиль рамки задан */
  padding: 11px;
  margin: 5px;
  box-sizing: border-box;  /* Включаем рамку в размеры элемента */
}

.word-input-field:focus {
  outline: none; /* Убираем стандартную обводку браузера */
  border-color: #00BB00; /* Зеленый цвет рамки при фокусе */
}

.hints-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 5px;
}

.hint-button, .hint-active-button {
  background-color: #ccc; /* Серый цвет для фона */
  color: rgba(0, 0, 0, 0.4); /* Полупрозрачный текст */
  border: none;
  width: 36px;
  height: 36px;
  margin: 2px;
  border-radius: 4px; /* Слегка скругленные углы */
  cursor: pointer;
}

.hint-active-button {
  background-color: var(--tg-theme-button-color); /* Серый цвет для фона */
  color: var(--tg-theme-button-text-color); /* Полупрозрачный текст */
}


.definition-display {
  color: var(--tg-theme-text-color);
  font-size: 14px; /* Меньше размер чем основное слово */

  margin-top: 0px;
  margin-bottom: 5px;
  opacity: 0.7;
  white-space: pre-wrap;
}

.inline-more-button {
  background-color: var(--tg-theme-hint-color);
  color: var(--tg-theme-button-text-color);
  border: none;
  padding: 4px;
  border-radius: 10px;
  font-size: 12px;
  cursor: pointer;
  display: inline-block; /* или display: inline; в зависимости от нужного вам стиля */
}


.word-submit-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #22c55e;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.word-submit-button :hover {
  color: #15803d; /* text-green-700 */
}

.hints-container.rtl-layout {
  direction: rtl;
  /* justify-content: flex-start; для rtl flex-start будет справа */
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/settings/WordChangeOverlay.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC,EAAE,eAAe;EACpD,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;;AAGA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB,GAAG,yBAAyB;EAC7C,mBAAmB,GAAG,oCAAoC;EAC1D,aAAa;EACb,WAAW;EACX,sBAAsB,GAAG,sCAAsC;AACjE;;AAEA;EACE,aAAa,EAAE,yCAAyC;EACxD,qBAAqB,EAAE,kCAAkC;AAC3D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB,EAAE,wBAAwB;EAChD,yBAAyB,EAAE,yBAAyB;EACpD,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB,EAAE,4BAA4B;EAChD,eAAe;AACjB;;AAEA;EACE,8CAA8C,EAAE,wBAAwB;EACxE,wCAAwC,EAAE,yBAAyB;AACrE;;;AAGA;EACE,iCAAiC;EACjC,eAAe,EAAE,qCAAqC;;EAEtD,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,qBAAqB,EAAE,4DAA4D;AACrF;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,cAAc;EACd,iEAAiE;AACnE","sourcesContent":[".word-menu {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 250px;\r\n  text-align: center;\r\n  background-color: var(--tg-theme-bg-color);\r\n  padding: 25px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 12px;\r\n  z-index: 1100;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.word-menu * {\r\n  touch-action: pan-y;\r\n}\r\n\r\n.word-display {\r\n  color: var(--tg-theme-button-color); /* Синий цвет */\r\n  font-size: 24px;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.word-menu-settings {\r\n  width: 95%;\r\n  margin-top: 4px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.word-menu-item {\r\n  width: 100%;\r\n  margin-top: 6px;\r\n  margin-bottom: 6px;\r\n  background-color: rgba(154, 154, 154, 0.1);\r\n  border-radius: 10px;\r\n}\r\n\r\n.word-menu-item-checkbox {\r\n  height: 20px;\r\n  width: 20px;\r\n  margin-left: 2px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.word-menu-item:hover {\r\n  background-color: rgba(154, 154, 154, 0.15);\r\n}\r\n\r\n\r\n.word-input-field {\r\n  background-color: var(--tg-theme-bg-color);\r\n  color: var(--tg-theme-text-color);\r\n  width: 95%;\r\n  font-size: 16px;\r\n  border-radius: 12px;\r\n  border-color: var(--tg-theme-button-color);\r\n  border-width: 2px;  /* Задаем толщину рамки */\r\n  border-style: solid;  /* Убедимся, что стиль рамки задан */\r\n  padding: 11px;\r\n  margin: 5px;\r\n  box-sizing: border-box;  /* Включаем рамку в размеры элемента */\r\n}\r\n\r\n.word-input-field:focus {\r\n  outline: none; /* Убираем стандартную обводку браузера */\r\n  border-color: #00BB00; /* Зеленый цвет рамки при фокусе */\r\n}\r\n\r\n.hints-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  margin: 5px;\r\n}\r\n\r\n.hint-button, .hint-active-button {\r\n  background-color: #ccc; /* Серый цвет для фона */\r\n  color: rgba(0, 0, 0, 0.4); /* Полупрозрачный текст */\r\n  border: none;\r\n  width: 36px;\r\n  height: 36px;\r\n  margin: 2px;\r\n  border-radius: 4px; /* Слегка скругленные углы */\r\n  cursor: pointer;\r\n}\r\n\r\n.hint-active-button {\r\n  background-color: var(--tg-theme-button-color); /* Серый цвет для фона */\r\n  color: var(--tg-theme-button-text-color); /* Полупрозрачный текст */\r\n}\r\n\r\n\r\n.definition-display {\r\n  color: var(--tg-theme-text-color);\r\n  font-size: 14px; /* Меньше размер чем основное слово */\r\n\r\n  margin-top: 0px;\r\n  margin-bottom: 5px;\r\n  opacity: 0.7;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.inline-more-button {\r\n  background-color: var(--tg-theme-hint-color);\r\n  color: var(--tg-theme-button-text-color);\r\n  border: none;\r\n  padding: 4px;\r\n  border-radius: 10px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  display: inline-block; /* или display: inline; в зависимости от нужного вам стиля */\r\n}\r\n\r\n\r\n.word-submit-button {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #22c55e;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 8px;\r\n  z-index: 10000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.word-submit-button :hover {\r\n  color: #15803d; /* text-green-700 */\r\n}\r\n\r\n.hints-container.rtl-layout {\r\n  direction: rtl;\r\n  /* justify-content: flex-start; для rtl flex-start будет справа */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
